export default __webpack_public_path__ + "static/PerceptionMap-2fddf068992291f16e8cb3288376b43f.png";